var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"pt-1"},[_c('h3',[_vm._v("Notes")])]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('input-handler',{attrs:{"path":(_vm.path + ".buildingNotes")}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }